import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 获取护理项目
export function queryeservicelist (params, data) {
  params.token = getToken()
  return request({ url: '/eservice/list', method: 'post', params, data })
}

// 增删改护理项目
export function updateeservice (data) {
  return request({ url: '/eservice/update', method: 'post', params: { token: getToken() }, data })
}

// 获取入住的个人护理项目
export function queryeservicepersonsetinglist (params, data) {
  params.token = getToken()
  return request({ url: '/eservice/personseting/list', method: 'post', params, data })
}

// 设置入住的个人护理项目
export function updateeservicepersonseting (data) {
  return request({ url: '/eservice/personseting/update', method: 'post', params: { token: getToken() }, data })
}

// 查询护理记录
export function queryeservicepersonrecordlist (params, data) {
  params.token = getToken()
  return request({ url: '/eservice/personrecord/list', method: 'post', params, data })
}

// 增删改护理记录
export function updateeservicepersonrecord (data) {
  return request({ url: '/eservice/personrecord/update', method: 'post', params: { token: getToken() }, data })
}

// 获取用药提醒
export function querymedpersonlist (params, data) {
  params.token = getToken()
  return request({ url: '/eservice/medperson/list', method: 'post', params, data })
}

// 增删改用药提醒
export function updatemedperson (data) {
  return request({ url: '/eservice/medperson/update', method: 'post', params: { token: getToken() }, data })
}

// 查询排班记录
export function querydayworklist (params, data) {
  params.token = getToken()
  return request({ url: '/eservice/daywork/list', method: 'post', params, data })
}

// 增删改电子排班
export function updatedaywork (data) {
  return request({ url: '/eservice/daywork/update', method: 'post', params: { token: getToken() }, data })
}
//  查询排班
export function queryworkshift (params, data) {
  params.token = getToken()
  return request({ url: '/queryworkshift', method: 'post', params, data })
}
// 创建排班
export function createworkshift (data) {
  return request({ url: '/createworkshift', method: 'post', params: { token: getToken() }, data })
}
// 编辑排班

export function updateworkshift (data) {
  return request({ url: '/updateworkshift', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/eservice.js